import { BaseSerializer } from "./baseSerializer.ts";
import {Feature} from "../feature.model.ts";

export class FeatureSerializer extends BaseSerializer {
    public deserialize(data: Record<string, any>): Feature {
        const feature = new Feature();

        this._copyAttributes(feature, data);

        return feature;
    }
}
